export default __webpack_public_path__ + "static/media/checkpoint0.05ee2c1d.txt";